import { React, useState, useEffect } from 'react';
import './style.css';
import { Strings } from '../../Constants';



const BitcoinChart = (data) => {
    const [rupeeInBTC, setRupeeInBTC] = useState(1000)
    const [numYear, setNumYear] = useState(4)
    const [totalPrice, setTotalPrice] = useState(21000)
    const btcPriceHistory = [
        { year: 2008, price: 3 },
        { year: 2009, price: 36 },
        { year: 2010, price: 1000 },
        { year: 2011, price: 2329 },
        { year: 2012, price: 2329 },
        { year: 2013, price: 73000 },
        { year: 2014, price: 54000 },
        { year: 2015, price: 28000 },
        { year: 2016, price: 66135 },
        { year: 2017, price: 1445000 },
        { year: 2018, price: 1253484 },
        { year: 2019, price: 1019810 },
        { year: 2020, price: 2138900 },
        { year: 2021, price: 5286330 },
        { year: 2022, price: 3047131 },
        { year: 2023, price: 1447131 }
    ]
    useEffect(() => {
        calculatePrice()
    }, [rupeeInBTC, numYear])

    const onChangeRupee = (e) => {
        if (e.target.validity.valid) {
            let rupee = (e.target.value).replace(/\D+/g, '');
            setRupeeInBTC(rupee)
        }
    }

    const onChangeYear = (e) => {
        if (e.target.validity.valid) {
            let yearDif = (e.target.value).replace(/\D+/g, '');
            setNumYear(yearDif)
        }
    }

    const calculatePrice = () => {
        let priceList = getPrice(numYear)
        let calPriceYearsBack = priceList ? (rupeeInBTC / priceList) : 0
        let priceListNow = getPrice(0)
        let priceNow = Math.round(priceListNow * calPriceYearsBack)
        setTotalPrice(priceNow)
    }
    function getPrice(yearsAgo) {
        const yearDif = new Date().getFullYear() - yearsAgo
        let data = btcPriceHistory.find(o => o.year === yearDif);
        return data ? data.price : 0;
    }

    useEffect(() => {
        document.getElementById("myinput").oninput = function () {
            var value = (this.value - this.min) / (this.max - this.min) * 100
            this.style.background = 'linear-gradient(to right, #FFE099 0%, #FFE099 ' + value + '%, #343739 ' + value + '%, #343739 100%)'
        };

        document.getElementById("myinputrange").oninput = function () {
            var value = (this.value - this.min) / (this.max - this.min) * 100
            this.style.background = 'linear-gradient(to right, #FFE099 0%, #FFE099 ' + value + '%, #343739 ' + value + '%, #343739 100%)'
        };
    }, [])

    var data = { rupeeInBTC, onChangeRupee, numYear, onChangeYear, totalPrice }

    // console.log(Number(data.rupeeInBTC).toLocaleString('en-IN'))
    return (
        <div className='container bitcoinChart'>
            <div className='bitSectionOne'>
                <div className='sectionOne-title'>
                    <h2 className='sectionOne-title col-12 col-xl-10'>Accumulate the <span className='sectionOne-titleColor'>best performing asset</span> of the past decade for free</h2>
                </div>
            </div>
            <div className='row d-flex flex-wrap justify-content-center align-items-center sectionHolder '>
                <ValueRange data={data} />
                <DisplayPrice data={data} />
            </div>
        </div>
    );
}



const ValueRange = ({ data }) => {
    return (
      
        <div className='col-12  col-md-6  b-sectionOne'>
            <div className='bitcoin-value'>
                <span>Value of bitcoin</span>
            </div>
            <div className='rupees d-flex'>
                <span className='rupees-title'>₹</span>
                <input type='number' className='amount' value={data.rupeeInBTC} onChange={data.onChangeRupee} autoFocus />
            </div>
            <div >
                <input id='myinput' type="range" min='1000' max='3047131' value={data.rupeeInBTC} onChange={data.onChangeRupee} className='value-bitcoin-slider' />
            </div>
            <div className=' before'>
                <span className='before-title'>Before</span>
            </div>
            <div className='years'>
                <span className='year'>{data.numYear}</span>
                <span className='years-title'>years</span>
            </div>
            <div className='chrome'>
                <input id='myinputrange' type="range" max='12' min='4' value={data.numYear} onChange={data.onChangeYear} className='value-bitcoin-slider' />
            </div>
        </div>
    )
}

const DisplayPrice = ({ data }) => {
    return (
        <div className='col-12  col-md-6 sectionTwo'>
            <div className='display-container'>
                <div className='col-12 col-md-12 col-lg-9 col-xl-7 sectiontwo-title'>
                    <span><span className='amntcolor'>₹ {data.rupeeInBTC}</span> of Bitcoin <span className='amntcolor'>{data.numYear}</span> years ago is now worth</span>
                </div>
                <div className='col-6 d-flex price-container'>
                    <span className='rupees-title1'>₹</span>
                    <span className='b-price ms-1'>{data.totalPrice.toLocaleString('en-IN')}</span>
                </div>
                <div className='col-12 col-md-12  sectiontwo-sub-title'>
                    <span>{Strings.BITCOIN_VALUE_SUBTITLE} </span>
                </div>
                {/* <div ref={reference}>
                            <button className='get-started-butn' onClick={click}>Get Started!</button>
                    </div> */}
            </div>
        </div>
    )
}

export default BitcoinChart;